export default __webpack_public_path__ + "locales/es/ChangePasswordDialog.json?hash=3b6ae498d5ea91bd0a9c65a1715c42b2";